import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from '../ui/Countdown';
export function Urgency() {
  return <section className="py-16 relative" data-id="element-304">
      <div className="container mx-auto px-4" data-id="element-305">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center p-8 md:p-12 rounded-3xl bg-red-950/20 border border-red-900/30" data-id="element-306">
          <h2 className="text-xl md:text-2xl font-bold text-white mb-8 flex items-center justify-center gap-2" data-id="element-307">
            <span aria-hidden="true" data-id="element-308">⏰</span> PRECIO DE LANZAMIENTO — CIERRA
            EN:
          </h2>

          <div className="mb-8" data-id="element-309">
            <Countdown data-id="element-310" />
          </div>

          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-red-500/10 text-red-400 font-medium text-sm mb-8 border border-red-500/20" data-id="element-311">
            <span aria-hidden="true" data-id="element-312">⚠️</span> Después sube $10.000 ARS. No
            vuelve.
          </div>

          <div className="max-w-md mx-auto" data-id="element-313">
            <div className="flex justify-between text-sm font-medium mb-2" data-id="element-314">
              <span className="text-red-400 flex items-center gap-1" data-id="element-315">
                <span aria-hidden="true" className="text-[10px]" data-id="element-316">
                  🔴
                </span>{' '}
                Cupos al precio de lanzamiento — Quedan pocos
              </span>
            </div>
            <div className="h-3 w-full bg-slate-800 rounded-full overflow-hidden border border-white/5" data-id="element-317">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '71%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="h-full bg-gradient-to-r from-red-600 to-red-400 rounded-full relative" data-id="element-318">
                <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(255,255,255,0.2)_50%,transparent_75%,transparent_100%)] bg-[length:20px_20px] animate-[shimmer_1s_linear_infinite]" data-id="element-319" />
              </motion.div>
            </div>
            <p className="text-xs text-slate-400 mt-2 text-right" data-id="element-320">
              71% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}